import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import Layout from "@/components/Layout";

const OrderCancelledPage = () => {
  return (
    <Layout>
      <section className="min-h-screen bg-gradient-to-b from-cream-100 to-cream-50 flex items-center justify-center px-6 py-24">
        <div className="max-w-lg w-full bg-white/60 backdrop-blur-sm rounded-2xl p-10 md:p-14 text-center">
          <div className="w-14 h-14 rounded-full border-2 border-foreground/20 flex items-center justify-center mx-auto mb-6">
            <X className="w-7 h-7 text-foreground/70" />
          </div>
          <span className="font-serif italic text-3xl text-foreground">Beställning</span>
          <h1 className="text-xl font-bold uppercase tracking-wider text-foreground mt-1">Avbruten</h1>
          <p className="text-sm text-muted-foreground mt-4">
            Du har avbrutit betalningen. Inga pengar har dragits.
            Du kan när som helst återgå och slutföra din beställning.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <Link
              to="/pricing"
              className="flex-1 bg-foreground text-background py-3.5 rounded-lg font-medium uppercase tracking-widest text-[10px] hover:bg-foreground/90 transition-all duration-300 inline-flex items-center justify-center gap-2"
            >
              Tillbaka till beställning <ArrowRight className="w-3 h-3" />
            </Link>
            <Link
              to="/account"
              className="flex-1 border border-foreground text-foreground bg-transparent py-3.5 rounded-lg font-medium uppercase tracking-widest text-[10px] hover:bg-foreground hover:text-background transition-all duration-300 inline-flex items-center justify-center gap-2"
            >
              Mitt konto <ArrowRight className="w-3 h-3" />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default OrderCancelledPage;
